function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 113.4c15.6 0 28.3 12.7 28.3 28.3S157.3 170 141.7 170s-28.3-12.7-28.3-28.3 12.7-28.3 28.3-28.3zm-85 0c15.6 0 28.3 12.7 28.3 28.3S72.3 170 56.7 170s-28.3-12.7-28.3-28.3 12.7-28.3 28.3-28.3zm170.1 0c15.6 0 28.3 12.7 28.3 28.3S242.4 170 226.8 170s-28.3-12.7-28.3-28.3 12.7-28.3 28.3-28.3z"
})));